import styled from 'styled-components'

export const PageWrapper = styled.div`
  height: 100%;

  .ant-tabs {
    height: calc(100% - 88px);

    .ant-tabs-content-holder {
      height: 100%;

      .ant-tabs-content {
        height: 100%;
      }
    }
  }
`
